<template>
  <v-card class="elevation-0">
    <l-map
      v-if="center"
      ref="map"
      style="height: 300px; width: 100%;"
      :zoom="zoom"
      :center="center"
      @update:zoom="zoomUpdated"
      @update:center="centerUpdated"
      @update:bounds="boundsUpdated"
    >
      <l-tile-layer
        :name="name"
        :url="url"
        :attribution="attribution"
      >
      </l-tile-layer>
      <l-marker
        :visible="visible"
        :draggable="draggable"
        :lat-lng.sync="position"
        @click="alert('Clicou')"
      ></l-marker>
    </l-map>
    <v-card-text
      class="pt-4"
      style="position: relative;"
    >
    <v-btn absolute top right fab @click="novaLocalizacao" style="z-index:5000; margin-top: -60px;" small color="gray lighten-2"><v-icon>pin_drop</v-icon></v-btn>
      <div class="pl-3">
        <h3 class="display-1 font-weight-light orange--text mb-2">Geolocalize seu posto</h3>
        <div class="font-weight-light title mb-2">
          Tentamos encontrar você pelo endereço<br>
          mas precisamos que você ajuste para finalizarmos.
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn
        flat
        color="primary"
        block
        @click="confirmarGeoposition"
      >
        Confirmar geolocalização
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { postosDao } from '@/api'
import { L, LMap, LTileLayer, LMarker } from 'vue2-leaflet'

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  data () {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: 'Map data © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
      name: 'OpenTopoMap',
      maxZoom: 18,
      zoom: 17,
      coordenadas: {
        latitude: null,
        longitude: null
      },
      bounds: null,
      center: null,
      draggable: true,
      nomeBtnLocalizacao: 'Nova Localização',
      localizacaoFlag: false
    }
  },
  watch: {
    posto (val) {
      if (val !== null && val !== undefined) {
        if (this.posto.latitude && this.posto.longitude) {
          this.carregarMapa(this.posto.latitude, this.posto.longitude)
        } else {
          if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition((position) => {
              this.carregarMapa(position.coords.latitude, position.coords.longitude)
            })
          } else {
            alert('Não é possível acessar a geolocalização do seu dispositivo.')
          }
        }
      }
    },
    endereco (val) {
      if (val !== null && val !== undefined) {
        try {
          this.buscarCoordenadas()
        } catch {
          console.log(Error('Não foi possível pegar as coordenadas geograficas do posto'))
        }
      }
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    },
    visible () {
      return !!this.position
    },
    posto () {
      return this.$store.getters.posto
    },
    endereco () {
      return this.$store.getters.endereco
    }
  },
  methods: {
    zoomUpdated (zoom) {
      this.zoom = zoom
    },
    centerUpdated (center) {
      this.center = center
    },
    boundsUpdated (bounds) {
      this.bounds = bounds
    },
    carregarMapa (latitude, longitude) {
      this.position = L.latLng(latitude, longitude)
      this.center = L.latLng(latitude, longitude)
      setTimeout(function () { window.dispatchEvent(new Event('resize')) }, 250)
    },
    novaLocalizacao () {
      if (this.localizacaoFlag === false) {
        this.carregarMapa(this.coordenadas.latitude, this.coordenadas.longitude)
        this.localizacaoFlag = true
      } else {
        this.carregarMapa(this.posto.latitude, this.posto.longitude)
        this.localizacaoFlag = false
      }
    },
    confirmarGeoposition () {
      this.$store.commit('setLoading', true)

      let body = {
        cnpj: this.posto.cnpj,
        latitude: this.position.lat,
        longitude: this.position.lng
      }

      postosDao.geolocatePosto(body, this.headers).then(response => {
        this.$store.commit('setLoading', false)
        if (response.ok) {
          this.$store.dispatch('geoposicionarPosto', this.position)
        } else {
          this.$store.commit('setError', { message: 'Não foi possível atualizar a gelocalização do posto' })
        }
      })
      this.$emit('info', 'Geolocalização atualizada com sucesso')
    },
    buscarCoordenadas () {
      return this.$store.dispatch('pegarCoordenadas', {
        logradouro: this.endereco.logradouro,
        numero: this.endereco.numero,
        bairro: this.endereco.bairro,
        cidade: this.endereco.cidade,
        estado: this.endereco.uf
      })
        .then(json => {
          this.coordenadas.latitude = json.latitude
          this.coordenadas.longitude = json.longitude
        })
    }
  },
  mounted () {
    if (this.posto) {
      if (this.posto.latitude && this.posto.longitude) {
        this.carregarMapa(this.posto.latitude, this.posto.longitude)
      } else {
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition((position) => {
            this.carregarMapa(position.coords.latitude, position.coords.longitude)
          })
          /* geolocation is available */
        } else {
          alert('Não é possível acessar a geolocalização do seu dispositivo.')
        }
      }
    }
  }
}
</script>
